import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import {
  ChangePasswordInterface,
  ForgotPasswordInterface,
  LoginCodeInterface,
  LoginInterface,
  RegisterInterface,
  ResponseLoginInterface,
  SetPasswordInterface,
} from '../interfaces/auth.interface';

import { environment } from '../../../environments/environment';
import { ResponseOk } from '../interfaces/general.interface';
import { CookieService } from 'ngx-cookie-service';

export const TOKEN_EXPIRE_TIME = 2 * 24 * 60 * 60;

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(public cookieService: CookieService, public http: HttpClient) {}

  login(data: LoginInterface): Observable<ResponseLoginInterface> {
    return this.http.post<ResponseLoginInterface>(
      environment.apiURL + 'web/user/login',
      data
    );
  }

  checkLoginCode(data: LoginCodeInterface): Observable<ResponseOk> {
    return this.http.post<ResponseOk>(
      environment.apiURL + 'web/user/checkLoginCode',
      data
    );
  }

  register(data: RegisterInterface): Observable<ResponseLoginInterface> {
    return this.http.post<ResponseLoginInterface>(
      environment.apiURL + 'web/user/register',
      data
    );
  }

  loginAdmin(data: LoginInterface): Observable<ResponseLoginInterface> {
    return this.http.post<ResponseLoginInterface>(
      environment.apiURL + 'admin/login',
      data
    );
  }

  refreshToken(refreshToken: string): Observable<ResponseLoginInterface> {
    return this.http.post<ResponseLoginInterface>(
      environment.apiURL + 'common/user/refreshToken',
      {
        refreshToken,
      }
    );
  }

  logout(): Observable<ResponseOk> {
    return this.http.post<ResponseOk>(
      environment.apiURL + 'common/user/logout',
      {}
    );
  }

  logoutAdmin(): Observable<ResponseOk> {
    return this.http.post<ResponseOk>(
      environment.apiURL + 'common/user/logout',
      {}
    );
  }

  changePassword(data: ChangePasswordInterface): Observable<ResponseOk> {
    return this.http.post<ResponseOk>(
      environment.apiURL + 'common/password/change',
      data
    );
  }

  forgotPassword(data: ForgotPasswordInterface): Observable<ResponseOk> {
    return this.http.post<ResponseOk>(
      environment.apiURL + 'common/password/reset',
      data
    );
  }

  setPassword(data: {
    token: string;
    password: string;
  }): Observable<ResponseOk> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers: headers };

    return this.http.post<ResponseOk>(
      environment.apiURL + 'common/password/set',
      data,
      options
    );
  }
}
